var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"container\"><header class=\"page-title\"><h1>{{vm.$title}}</h1></header><section class=\"main col-lg-12\"><p>{{vm.$message}}</p><p ng-if=\"vm.$sentryId\">Sollten Sie Unterstützung bei diesem Problem benötigen, geben Sie bitte die folgende Kennung an: <strong>{{ vm.$sentryId }}</strong>.</p><p><a ui-sref=\"root.home\" class=\"btn btn-primary\">Zur Startseite</a></p></section></div>");;return buf.join("");
}